import Layout from './layout';
import Sider from './Sider';
Layout.Sider = Sider;
export default Layout;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/layout/index.js
// module id = 792
// module chunks = 0